module.exports = require('./helpers/bundle-url').getBundleURL('5E64i') + "logo-dark.eefe0b7f.svg";